module.exports = __webpack_public_path__ + "static/media/jinzihan.c4dee91f.png";